import React, { useState, useRef, useEffect } from 'react';
import { Popover, Button, Typography, Box } from '@mui/material';
import { DateTime } from 'luxon';
import './NewDatePicker.css';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { localGetItem } from '../../Utility/Services/CacheProviderService';
import { set } from 'date-fns';

const getDatesArray = (year, month) => {
    const date = new Date(year, month, 1);
    const dates = [];
    const firstDay = new Date(year, month, 1).getDay();
    const leadingEmptyDays = Array(firstDay).fill(null);

    while (date.getMonth() === month) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }

    return [...leadingEmptyDays, ...dates];
};

const getDayNames = () => {
    const base = new Date(2023, 9, 1); // Sunday
    const names = [];
    for (let i = 0; i < 7; i++) {
        names.push(base.toLocaleDateString(undefined, { weekday: 'short' }));
        base.setDate(base.getDate() + 1);
    }
    return names;
};

const NewDatePicker = (props) => {
    const anchorRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [lastSettedDate, setLastSettedDate] = useState("to");

    const [currentMonth, setCurrentMonth] = useState(new Date());

    let Settings = localGetItem("PharmaSettings") === null ? {} : JSON.parse(localGetItem("PharmaSettings"))
    let RoleData = localGetItem("loggedInUserInfo") === null ? {} : JSON.parse(localGetItem("loggedInUserInfo"))
    let PharmaRestirictionWeek = RoleData.is_user ? (props.PharmaDateFilterRestriction === true && (Settings?.report_date_config === "last7days")) : false
    let PharmaRestirictionMonth = RoleData.is_user ? (props.PharmaDateFilterRestriction === true && (Settings?.report_date_config === "last30days")) : false
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser;
    let howManyDays = RoleData.module_name === "Pharmacy" ? (props?.days ? props?.days : 90) : (props?.MaxDaysCount ? props?.MaxDaysCount : 30);
    let EndDate = startDate ? new Date(startDate?.getTime() + howManyDays * 24 * 60 * 60 * 1000) < new Date().getTime() ? new Date(startDate.getTime() + howManyDays * 24 * 60 * 60 * 1000) : new Date() : new Date()
    let FromDateRestriction = new Date()
    if (window.location.pathname === "/ChartDashboard") {
        FromDateRestriction = new Date("2024-02-01")
    }
    else if (window.location.pathname === "/FOReports/PatientReport/CreditSettlementReport") {
        FromDateRestriction = new Date("2024-04-01")
    }
    else {
        FromDateRestriction = new Date("2017-01-01")
    }
    if (PharmaRestirictionWeek && startDate) {
        FromDateRestriction = new Date(startDate?.getTime() - 7 * 24 * 60 * 60 * 1000)
    }
    else if (PharmaRestirictionMonth && startDate) {
        FromDateRestriction = new Date(startDate?.getTime() - 30 * 24 * 60 * 60 * 1000)
    }

    const minDate = props?.FromDateOpen ? new Date(props.FromDateOpen) : props?.RestrictPast ? new Date(2017, 0, 1) : new Date(2017, 0, 1); // fallback 
    const maxDate = props?.ToDateOpen ? new Date(props.ToDateOpen) : props?.EnableFuture ? null : props?.fromStockValue ? endDate : (window.location.pathname === "/IPHome" ? new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) : EndDate); // fallback

    if (minDate) minDate.setHours(0, 0, 0, 0);
    if (maxDate) maxDate.setHours(0, 0, 0, 0);

    useEffect(() => {
        if (props.FromDate && props.ToDate) {
            const from = props.FromDate ? new Date(props.FromDate) : new Date;
            from.setHours(0, 0, 0, 0);
            setStartDate(from);
            const to = props.ToDate ? new Date(props.ToDate) : new Date();
            to.setHours(0, 0, 0, 0);
            setCurrentMonth(new Date(to.getFullYear(), to.getMonth(), 1));
            setEndDate(to);
        }
        setAnchorEl(anchorRef.current);
    }, []);

    const handleClose = () => {
        setAnchorEl(null);
        if (props.PopClose) {
            props.PopClose(); // Call the PopClose function from props (closing popover)
        }
    };

    const handlePrevMonth = () => {
        const prev = new Date(currentMonth);
        prev.setMonth(currentMonth.getMonth() - 1);
        if (!minDate || prev >= minDate) {
            setCurrentMonth(prev);
        }
    };

    const handleNextMonth = () => {
        const next = new Date(currentMonth);
        next.setMonth(currentMonth.getMonth() + 1);
        // if (!maxDate || next <= maxDate) {
        setCurrentMonth(next);
        // }
    };

    const HandleTodate = (newvalue) => {
        let RoleData = localGetItem("loggedInUserInfo") === null ? {} : JSON.parse(localGetItem("loggedInUserInfo"));
        let howManyDays = RoleData.module_name === "Pharmacy" ? (props?.days ? props?.days : 90) : (props?.MaxDaysCount ? props?.MaxDaysCount : 30);
        let toDate = new Date(newvalue.getTime() + howManyDays * 24 * 60 * 60 * 1000);
        const toDay = toDate.getDate();
        const getLastDayOfMonth = (date) => {
            return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        };

        if (props?.fromStockValue) {
            let ToDateData = (newvalue != null && newvalue != new Date().getDate()) ?
                (newvalue !== null && toDay === 30 && getLastDayOfMonth(toDate) === 31 && (toDate < new Date().getTime())) ?
                    new Date(toDate.getFullYear(), toDate.getMonth(), getLastDayOfMonth(toDate)) :
                    new Date(newvalue.getTime() + howManyDays * 24 * 60 * 60 * 1000) < new Date().getTime() ?
                        new Date(newvalue.getTime() + howManyDays * 24 * 60 * 60 * 1000) : new Date(Date.now() - 864e5) : new Date()
            if (ToDateData) {
                ToDateData.setHours(0, 0, 0, 0);
            }
            setEndDate(ToDateData)
        } else {
            let ToDateData;
            if (newvalue) {
                if (toDay === 30 && getLastDayOfMonth(toDate) === 31 && (toDate < new Date().getTime())) {
                    ToDateData = new Date(toDate.getFullYear(), toDate.getMonth(), getLastDayOfMonth(toDate));
                } else if (!props.EnableFuture && toDate > new Date()) {
                    ToDateData = new Date();
                } else {
                    ToDateData = toDate;
                }
            }
            if (ToDateData) {
                ToDateData.setHours(0, 0, 0, 0);
            }
            setEndDate(ToDateData)
        }
    };

    const handleDateClick = (date) => {
        if (props?.AllowAllDate) {
            if (!startDate || lastSettedDate === "to" || date < startDate) {
                setStartDate(date);
                setEndDate(null);
                setLastSettedDate("from");
            } else {
                setEndDate(date);
                setLastSettedDate("to");
            }
        } else if (!startDate || !endDate || date < startDate || date > endDate) {
            setStartDate(date);
            setEndDate(null);
            setLastSettedDate("from");
            HandleTodate(date);
        } else if (lastSettedDate === "from" && date >= startDate) {
            setEndDate(date);
            setLastSettedDate("to");
        } else if (lastSettedDate === "to" && date < startDate) {
            setStartDate(date);
            setEndDate(null);
            setLastSettedDate("from");
            HandleTodate(date);
        } else {
            setStartDate(date);
            setEndDate(null);
            setLastSettedDate("from");
            HandleTodate(date);
        }
    };

    const handleCustomDate = () => {
        if (startDate && endDate) {
            props.CustomDates(
                DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd'),
                DateTime.fromJSDate(endDate).toFormat('yyyy-MM-dd')
            );
        }
    };

    const handleYearSelect = (year) => {
        const updated = new Date(currentMonth);
        updated.setFullYear(year);
        if (updated >= minDate || !minDate) {
            if (updated > new Date() && !props?.EnableFuture) {
                updated.setMonth(new Date().getMonth());
            }
            setCurrentMonth(updated);
        } else {
            setCurrentMonth(new Date(minDate.getFullYear(), minDate.getMonth(), 1));
        }
    };


    const isSameDay = (a, b) => a && b && a.toDateString() === b.toDateString();
    const isInRange = (date) => startDate && endDate && date > startDate && date < endDate;
    const isDisabled = (date) => {
        return (
            (minDate && date < minDate) ||                 // block before minDate
            (maxDate && date > maxDate) ||                 // block after maxDate
            (!props?.EnableFuture && date > new Date() && (!maxDate || date <= maxDate)) // block future only if no maxDate
        );
    };
    const isToday = (date) => date.toDateString() === new Date().toDateString();

    const prevMonth = new Date(currentMonth);
    prevMonth.setMonth(currentMonth.getMonth() - 1);
    const dayNames = getDayNames();

    const minYear = minDate?.getFullYear() || 2017;

    return (
        <div ref={anchorRef} className="date-range-wrapper">
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                anchorPosition={{ top: 190, left: window.location.pathname === "/PharmacyReports/PurchaseWiseEnquiry" ? 200 : props?.customLeft ? +props?.customLeft : 800 }}
                PaperProps={{ className: 'popover-content' }}
            >
                {/* Top Navigation */}
                <div className="nav-bar">
                    <div className="nav-buttons">
                        <Button
                            size='small'
                            onClick={handlePrevMonth}
                            sx={{ textTransform: "capitalize", fontWeight: 600, color: 'black' }}
                            disabled={(new Date(currentMonth).setMonth(currentMonth.getMonth() - 1) < minDate) && minDate}
                            startIcon={<KeyboardArrowLeftIcon />}
                        >
                            Prev Month
                        </Button>
                        <select
                            value={currentMonth.getFullYear()}
                            onChange={(e) => handleYearSelect(parseInt(e.target.value))}
                            className="year-dropdown"
                        >
                            {Array.from({ length: ((props?.EnableFuture ? new Date().getFullYear() + 2 : new Date()?.getFullYear()) - minYear + 1) }, (_, i) => {
                                const year = minYear + i;
                                return (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                );
                            })}
                        </select>
                        <Button
                            size='small'
                            onClick={handleNextMonth}
                            sx={{ textTransform: "capitalize", fontWeight: 600, color: 'black' }}
                            disabled={
                                (maxDate && new Date(currentMonth).setMonth(currentMonth.getMonth() + 1) > maxDate) ||
                                (!props?.EnableFuture && (!maxDate || new Date(currentMonth).setMonth(currentMonth.getMonth() + 1) > maxDate) && new Date(currentMonth).setMonth(currentMonth.getMonth() + 1) > new Date())
                            }
                            endIcon={<KeyboardArrowRightIcon />}
                        >
                            Next Month
                        </Button>

                    </div>
                </div>


                {/* Calendars */}
                <div className="calendar-wrapper">
                    {[prevMonth, currentMonth].map((monthDate, i) => {
                        const dates = getDatesArray(monthDate.getFullYear(), monthDate.getMonth());
                        const monthName = monthDate.toLocaleString('default', { month: 'long' });
                        const year = monthDate.getFullYear();
                        return (
                            <div key={i} className="calendar">
                                {/* Month and Year at the top of each calendar */}
                                <div className="calendar-header">
                                    <Typography sx={{ fontWeight: 600, color: 'black' }}>
                                        {monthName} {year}
                                    </Typography>
                                </div>

                                <div className="calendar-grid">
                                    {dayNames.map((day) => (
                                        <div key={day} className="day-name">{day}</div>
                                    ))}
                                    {dates.map((date, index) =>
                                        date ? (
                                            <div
                                                key={index}
                                                className={`date-cell
                  ${isSameDay(date, startDate) ? 'start' : ''}
                  ${isSameDay(date, endDate) ? 'end' : ''}
                  ${isInRange(date) ? 'in-range' : ''}
                  ${isToday(date) ? 'today' : ''}
                  ${isDisabled(date) ? 'disabled' : ''}
                `}
                                                onClick={() => !isDisabled(date) && handleDateClick(date)}
                                            >
                                                {date.getDate()}
                                            </div>
                                        ) : (
                                            <div key={index} className="empty-cell" />
                                        )
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
                {/* Footer */}
                <div className="popover-footer">
                    <div className="selected-range" style={{ display: "flex", gap: "1vw" }}>
                        {startDate &&
                            <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
                                <Typography sx={{ fontWeight: 600, fontSize: "1dvw" }}>From : </Typography>
                                <Typography sx={{ fontWeight: 500, fontSize: "1dvw" }}>{DateTime.fromJSDate(startDate).toFormat('dd-MM-yyyy')}</Typography>
                            </Box>}
                        {endDate &&
                            <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
                                <Typography sx={{ fontWeight: 600, fontSize: "1dvw" }}>To : </Typography>
                                <Typography sx={{ fontWeight: 500, fontSize: "1dvw" }}>{DateTime.fromJSDate(endDate).toFormat('dd-MM-yyyy')}</Typography>
                            </Box>}
                    </div>
                    <div>
                        <Button sx={{ textTransform: "capitalize" }} onClick={() => {
                            setStartDate(new Date());
                            setEndDate(new Date());
                            setCurrentMonth(new Date());
                        }} size="small">Today</Button>
                        <Button sx={{ textTransform: "capitalize" }} onClick={() => {
                            setStartDate(null);
                            setEndDate(null);
                        }} variant="outlined" size="small">Clear</Button>
                        <Button sx={{ textTransform: "capitalize", marginLeft: '1vw' }} onClick={handleClose} variant="outlined" size="small">Close</Button>
                        <Button disabled={!startDate || !endDate} sx={{ textTransform: "capitalize", marginLeft: '1vw' }} onClick={handleCustomDate} variant="contained" color="primary" size="small">Search</Button>
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export default NewDatePicker;
